// Import the layout actions
import { LOCATION_CHANGE } from "#/_Bootstrap/GlobalConstants.ts";
import { OPEN_CUSTOMER_DISPLAY } from "#/Actions/CustomerDisplay/CustomerDisplayActions.ts";
import {
    BODY_DISPLAY_LOADING,
    BODY_DISPLAY_OVERLAY,
    BODY_HIDE_LOADING,
    BODY_HIDE_OVERLAY,
    LAYOUT_AUDIO_TOGGLE,
    LAYOUT_BODY_CLICK,
    LAYOUT_NOTIFICATIONS_TOGGLE,
    LAYOUT_QUICK_MENU_TOGGLE,
    LAYOUT_SYNCHRONISE_TOGGLE,
    LAYOUT_TOGGLE_MENU,
    LAYOUT_USER_MENU_TOGGLE,
    type LayoutActionTypes,
    type LayoutState,
    PAGE_FOCUS_GAINED,
    PAGE_FOCUS_LOST,
} from "#/Actions/General/LayoutActions.ts";
import { NAVIGATION_CLICKED } from "#/Actions/General/NavigationActions.ts";
import { USER_LOGOUT } from "#/Actions/Users/UserVariables.ts";
import { type ShopfrontActions } from "#/Utilities/Generic/ActionsHelper.ts";
import { getOption } from "#/Utilities/Platform/Options/Options.ts";

/**
 * General Layout Reducer Function
 */
function LayoutReducer(state: LayoutState | undefined, action: ShopfrontActions<LayoutActionTypes>): LayoutState {
    const changedState: LayoutState = {
        menu: {
            open: false,
        },
        body: {
            overlay: false,
            loading: false,
        },
        userMenu: {
            open: false,
        },
        notifications: {
            open: false,
        },
        quickMenu: {
            open: false,
        },
        synchronise: {
            open: false,
        },
        audio: {
            open: false,
        },
        focus: true,
    };

    if(typeof state === "undefined") {
        return changedState;
    }

    switch(action.type) {
        case LAYOUT_BODY_CLICK:
        case NAVIGATION_CLICKED:
        case OPEN_CUSTOMER_DISPLAY:
        case LOCATION_CHANGE:
            changedState.menu.open = false;
            changedState.body.overlay = false;
            changedState.userMenu.open = false;
            changedState.notifications.open = false;
            changedState.quickMenu.open = false;
            changedState.synchronise.open = false;
            changedState.audio.open = false;
            break;
        case USER_LOGOUT:
            changedState.menu.open = false;
            changedState.body.overlay = state.body.overlay;
            changedState.userMenu.open = false;
            changedState.notifications.open = false;
            changedState.quickMenu.open = false;
            changedState.synchronise.open = false;
            changedState.audio.open = false;
            break;
        case LAYOUT_TOGGLE_MENU:
            changedState.menu.open = !state.menu.open;
            changedState.body.overlay = false;
            changedState.userMenu.open = false;
            changedState.notifications.open = false;
            changedState.quickMenu.open = false;
            changedState.synchronise.open = false;
            changedState.audio.open = false;
            break;
        case LAYOUT_USER_MENU_TOGGLE:
            changedState.menu.open = false;
            changedState.userMenu.open = !state.userMenu.open;
            changedState.body.overlay = false;
            changedState.notifications.open = false;
            changedState.quickMenu.open = false;
            changedState.synchronise.open = false;
            changedState.audio.open = false;
            break;
        case LAYOUT_NOTIFICATIONS_TOGGLE:
            changedState.menu.open = false;
            changedState.notifications.open = !state.notifications.open;
            changedState.body.overlay = false;
            changedState.userMenu.open = false;
            changedState.quickMenu.open = false;
            changedState.synchronise.open = false;
            changedState.audio.open = false;
            break;
        case LAYOUT_QUICK_MENU_TOGGLE:
            changedState.menu.open = false;
            changedState.quickMenu.open = !state.quickMenu.open;
            changedState.body.overlay = changedState.quickMenu.open;
            changedState.userMenu.open = false;
            changedState.notifications.open = false;
            changedState.synchronise.open = false;
            changedState.audio.open = false;
            break;
        case LAYOUT_SYNCHRONISE_TOGGLE:
            changedState.menu.open = false;
            changedState.userMenu.open = false;
            changedState.notifications.open = false;
            changedState.quickMenu.open = false;
            changedState.synchronise.open = !state.synchronise.open;
            changedState.body.overlay = changedState.synchronise.open;
            changedState.audio.open = false;
            break;
        case LAYOUT_AUDIO_TOGGLE:
            changedState.menu.open = false;
            changedState.userMenu.open = false;
            changedState.notifications.open = false;
            changedState.quickMenu.open = false;
            changedState.synchronise.open = false;
            changedState.audio.open = !changedState.audio.open;
            changedState.body.overlay = changedState.audio.open;
            break;
        case BODY_DISPLAY_OVERLAY:
            changedState.body.overlay = true;
            break;
        case BODY_HIDE_OVERLAY:
            changedState.body.overlay = false;
            break;
        case BODY_DISPLAY_LOADING:
            changedState.body.loading = true;
            changedState.body.overlay = true;
            break;
        case BODY_HIDE_LOADING:
            changedState.body.loading = false;
            changedState.body.overlay = false;
            break;
        case PAGE_FOCUS_LOST:
            return {
                ...state,
                focus: getOption("prevent_blur"),
            };
        case PAGE_FOCUS_GAINED:
            return {
                ...state,
                focus: true,
            };
        default:
            // Not our change
            return state;
    }

    return changedState;
}

export default LayoutReducer;
